import { convertStringInDate, sum } from "~services/GlobalServices";
import { applyRandomId, createDateInput, createVolumeInput } from "../utils";

const useFunnelDashboard = ({setShowVolumeUpdateModal, verificaDataProximaNegociacao, lastStatusProdutos, handleVolumeUpdate, handleUpdateAllData}) => {

const convertProductToTable = (products_grouped) => {
  let keys = Object.keys(products_grouped);
  let values = Object.values(products_grouped);
  let content = [];

  values.map((value, index) => {
    const objHeader = {
      label: "Próxima Negociação:",
      value: keys[index],
      dataNegociacao: value[0].dataNegociacao,
      id: value[0].id,
      etapa: value[0].etapa,
      etapaSlug: value[0].etapaSlug,
    };

    const accordion_header = defineTableHeader({
      ...objHeader,
      layoutFields: { value: "Etapa " },
      values: value
    });

    const accordion_body = defineTableBody(value);

    const accordion = {
      accordion_header,
      accordion_body,
      error: verificaDataProximaNegociacao(value)
    };

    content.push(accordion);

    return accordion;
  });

  return content;
};


  const defineTableHeader = ({label, grupoProdutoId, dataNegociacao, etapa, id, etapaSlug, deleteBy, layoutFields, values}) => {
    return {
      label,
      table_layout: true,
      funilObraGrupoProdutoId: grupoProdutoId,
      id,
      etapa,
      etapaSlug,
      deleteBy,
      layout_fields: layoutFields,
      table_data: {
        header: {
          data: applyRandomId([
            createDateInput({ header: {
              funilObraGrupoProdutoId: grupoProdutoId,
              id,
              etapa,
              etapaSlug,
              dataNegociacao,
              deleteBy,
            }, handleUpdate: handleUpdateAllData, value: dataNegociacao }),
            { label: "Volume Total", value: sum(values, "volumeEstimado") },
            { label: "Último Status", value: lastStatusProdutos(values) },
          ]),
        },
      }
    }
  }

  const defineTableBody = (value) => {
      let body = null;
      let rows = [];

      const values = value;

      rows = values.map(e => {
        return {
          ...e,
          columns: applyRandomId([
            { value: e.label},
            { value: e.grupoNome},
            { value: e.produtoNome ?? "-"},
            createVolumeInput({ header: e, handleUpdate: handleVolumeUpdate, value: e.volumeEstimado, label: false }),
            { value: e.status},
          ]),
          dados: {
            ...e,
            deleteBy: ['id'],
            dashboard: true
          }
        }
      });

      let sub = {
        showSelectAll: false,
        header: {
          data:[
            { label: "Cliente" },
            { label: "Produto" },
            { label: "SKU" },
            { label: "Volume" },
            { label: "Status" },
          ]
        },
        body: {
          actionButtons: ["edit", "delete"],
          rows,
        },
      };

      body = {
        actionButtons: [],
        header: {
          data: [
          ]
        },
        rows: [],
      };

      sub = {
        ...sub,
        is_accordion: false,
        show_more_header: true,
      };

      return {
        data: {
          body,
        },
        sub,
      };
    };

  return {
    convertProductToTable,
  };
};

export default useFunnelDashboard;
